const compactNumberFormat = new Intl.NumberFormat('en-US', {
  maximumSignificantDigits: 2,
  compactDisplay: 'short',
  notation: 'compact',
  roundingMode: 'floor',
});
const aboveThounsandNumberFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  roundingMode: 'floor',
});
const aboveOneNumberFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  roundingMode: 'trunc',
});
const belowOneNumberFormat = new Intl.NumberFormat('en-US', {
  maximumSignificantDigits: 4,
  minimumSignificantDigits: 4,
  roundingMode: 'trunc',
});

export type AmountFormatConfig = { isInteger?: boolean; compact?: boolean };
export function amountFormat(
  amount: number,
  config: AmountFormatConfig = {},
): string {
  const isInteger = config.isInteger || false;
  const compact = config.compact || false;

  if (amount === 0 && !isInteger) return '0.00';
  if (amount === 0 && isInteger) return '0';

  let numberFormat: Intl.NumberFormat;
  if (compact) {
    numberFormat = compactNumberFormat;
  } else if (amount > 1000 || isInteger) {
    numberFormat = aboveThounsandNumberFormat;
  } else if (amount >= 1) {
    numberFormat = aboveOneNumberFormat;
  } else {
    numberFormat = belowOneNumberFormat;
  }

  return numberFormat.format(amount);
}
